<div class="overlay" *ngIf="IsPopup">
  &nbsp;
</div>
<div [ngClass]="IsPopup ? 'message-box-wrapper center-full' : ''">
  <div class="{{localService.selectedLanguageCode}}">
    <div class="modal-header" *ngIf="IsHeaderVisible">
      <h5 class="modal-title">{{header ? header : (IsConfirmationType ?
        localService.languageContent.common.need_confirmation : localService.languageContent.common.message)}}</h5>
      <button class="button_icon button_icon_color popup_close" *ngIf="IsPopup"
        style="transform: rotate(45deg);color: palevioletred !important;font-size: 25px;" (click)="onPopupClose()"
        title="{{localService.languageContent.common.close}}">add_circle_outline</button>
    </div>
    <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row" *ngIf="!IsHtmlMessage">
        <div class="col-md-12" style="text-align: justify; line-height: 30px;">
          {{message && message.length > 0 ? message : (IsConfirmationType ?
          localService.languageContent.common.need_confirmation_message : '')}}
        </div>
      </div>
      <div *ngIf="IsHtmlMessage && htmlMessage" [innerHTML]="htmlMessage"> </div>
    </div>
    <div class="modal-footer">
      <div *ngIf="customButtonText != ''">
        <button type="button" class="btn btn-secondary" (click)="onConfirmed(true)">
          {{customButtonText}}{{timerCount == 0 ? '' : '&nbsp;(' + timerCount + ')&nbsp;'}}
        </button>
      </div>
      <div *ngIf="IsConfirmationType">
        <div *ngIf="IsYesPrimaryOnConfirmationType">
          <button type="button" class="btn btn-secondary" style="color:white;background-color:red;"
            (click)="onConfirmed(false)">{{localService.languageContent.common.no}}</button>
          &nbsp;
          <button type="button" class="btn btn-secondary"
            (click)="onConfirmed(true)">{{localService.languageContent.common.yes}}</button>
        </div>
      </div>
      <div *ngIf="!IsYesPrimaryOnConfirmationType">
        <button type="button" class="btn btn-secondary" style="color:white;background-color:red;"
          (click)="onConfirmed(true)">{{localService.languageContent.common.yes}}</button>
        &nbsp;
        <button type="button" class="btn btn-secondary"
          (click)="onConfirmed(false)">{{localService.languageContent.common.no}}</button>
      </div>
    </div>
  </div>
</div>